import useSWR from 'swr'

import useAxios from './useAxios'
import { useSelector } from 'react-redux'
import { RootState } from '../store'
import { Order } from '../types'

interface OrdersListResponse {
  orders: Order[]
}

const useOrderList = () => {
  const instance = useAxios()
  const token = useSelector((state: RootState) => state.app.token)
  const url = `ac/v1/orders`
  const fetcher = () => instance.get(url).then((r) => r.data)

  const { data, error, isValidating } = useSWR<OrdersListResponse>([url, token], fetcher)

  return {
    response: data || { orders: [] },
    isLoading: !error && !data,
    isValidating,
    isError: error,
  }
}

export default useOrderList
